export default __webpack_public_path__ + "locales/passes.ky.json";